const CURRENCY_SYMBOLS: Record<string, string> = { INR: '₹', USD: '$', EUR: '€', GBP: '£', AED: 'د.إ' };

const num = (v: any) => (v === null || v === undefined || v === '' ? NaN : parseFloat(v));
const fmt = (currency: string, v: number) => `${CURRENCY_SYMBOLS[currency] || currency || ''}${v.toFixed(2)}`;

/**
 * A public storefront product's price, ready to show: `now` (the discount price
 * when there is one), `was` (the struck-out list price) and `off` (whole %).
 * null when the product has no price — price is optional, and showing it used
 * to print "₹NaN".
 */
export const priceParts = (p: { price?: any; discount_price?: any; discount_percent?: any; currency?: string }) => {
    const price = num(p.price);
    const discount = num(p.discount_price);
    const currency = p.currency || 'INR';
    if (!isNaN(discount)) {
        return {
            now: fmt(currency, discount),
            was: isNaN(price) ? null : fmt(currency, price),
            off: p.discount_percent ? Math.round(Number(p.discount_percent)) : null,
        };
    }
    if (isNaN(price)) return null;
    return { now: fmt(currency, price), was: null, off: null };
};
